import httpHelper from "@/helpers/httpHelper";
// action types
export const GET_DETAILS_SHARING = "getDetailsSharing";
export const GET_INQUIRY_SHEBA = "getInquirySheba";
// mutation types
export const SET_DETAILS_SHARING = "setDetailsSharing";
export const SET_INQUIRY_SHEBA = "setInquirySheba";


export default {
    state: {
        detailsSharing: {},
        status: '',
        dataInquiry: {}
    },
    getters: {
        /**
         * Get list of detailsSharing for current page
         * @param state
         * @returns {*}
         */
        loadedDetailsSharing(state) {
            return state.detailsSharing;
        },
        loadedInquiry(state) {
            return state.dataInquiry;
        }

    },
    actions: {
        /**
         * Set the detailsSharing list
         * @param state
         * @param payload
         */
        [GET_DETAILS_SHARING](state, payload) {
            httpHelper
                .getData(`/sharing/${payload}`)
                .then((response) => {
                    state.commit(SET_DETAILS_SHARING, response);

                })
                .catch((error) => {})
                .finally(() => {});

        },
        /**
         * Set the inquirySheba Status 
         * @param state
         * @param payload
         */
        [GET_INQUIRY_SHEBA](state, payload) {
            
            return new Promise((resolve, reject) => {
                httpHelper
                    .getData(`${payload.api}/${payload.id}`)
                    .then((response) => {
                        state.commit(SET_INQUIRY_SHEBA, response);
                        resolve(response.data);
                    })
                    .catch((error) => {
                        reject(error)
                    })
                    .finally(() => {});
            });
        },
    },
    mutations: {
        // [SET_DETAILS_SHARING](state, payload) {
        //     state.detailsSharing = [...state.detailsSharing, payload];
        // },
        [SET_DETAILS_SHARING](state, payload) {
            state.detailsSharing = payload;
        },
        [SET_INQUIRY_SHEBA](state, payload) {
            state.dataInquiry = payload;
        }
    }
};